import ToggleButtonGroup, { ToggleButtonGroupProps } from '@mui/material/ToggleButtonGroup';
import { styled } from '@mui/material';

export const Component = styled(ToggleButtonGroup)<ToggleButtonGroupProps>(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    gap: '5px',
    padding: '5px',
    borderRadius: '10px',
    '& .MuiToggleButtonGroup-grouped': {
        border: 0,
        '&:not(:first-of-type)': {
            borderRadius: '5px',
        },
        '&:first-of-type': {
            borderRadius: '5px',
        },
        '&.MuiToggleButton-sizeSmall': {
            padding: '4px',
        },
        '&.MuiToggleButton-sizeMedium': {
            padding: '12px',
        },
        '.MuiSvgIcon-fontSizeSmall': {
            fontSize: '20px',
        },
        '.MuiSvgIcon-fontSizeMedium': {
            fontSize: '24px',
        },
        '.MuiSvgIcon-fontSizeLarge': {
            fontSize: '35px',
        },
    },
}));
